import { Component } from '@angular/core';
import { ActionSheetController, IonicPage, Platform, ViewController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-select-image-popup',
  templateUrl: 'select-image-popup.html',
})
export class SelectImagePopupPage {
img:any = null;
  constructor(
    public viewCtrl: ViewController,
    public platform: Platform,
    public actionSheetController: ActionSheetController,
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectImagePopupPage',this.viewCtrl.data);
    if(this.viewCtrl.data.param){
      this.img = this.viewCtrl.data.param
    }
  }

  closeModal(){
    this.viewCtrl.dismiss()
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-image-popup/select-image-popup.ts